export const listAlignmentSuggestions = `
items {
  id
  sk
  maturity
  alignments {
    items {
      id
      sk
      scope
      abbreviation
      content
    }
  }
}
`;

export const listFilesForTask = /* GraphQL */ `
items {
  id
  idInc
  sk
  type
  name
  description
  schemaVersion
  file {
    name
    region
    bucket
    key
    size
    mimetype
    format
    extension
  }
  workspaceId
  createdAt
  updatedAt
}
nextToken
`;
